/** What startup needs; main.ts passes the real ones, tests pass fakes. */
export interface BootDeps {
    root: HTMLElement
    start: () => Promise<void>
    /** Sends a failed startup to error tracking; the page only tells the user. */
    report?: (error: unknown) => void
}

/** Runs startup, and if it fails shows a readable message instead of a blank page. */
export async function boot(deps: BootDeps): Promise<void> {
    try {
        await deps.start()
    } catch (error) {
        deps.report?.(error)
        const message = error instanceof Error ? error.message : String(error)
        deps.root.textContent = `HARM se nepodařilo spustit / HARM could not start: ${message}`
    }
}
